/**
 * Created by neo on 01.06.17.
 */

import { observable } from 'mobx';
import { default as FlightOffer, FlightOfferAircraft } from '../FlightOffer'


export default class FlightAircraft extends FlightOfferAircraft {
  @observable flight_offer: FlightOffer;

  constructor(json?: any) {
    super(json);

    if(json) {
      this.flight_offer = new FlightOffer(json.flight_offer);
    }
  }
};



// WEBPACK FOOTER //
// ./src/App/Store/Flight/FlightAircraft.js